(function () {
  'use strict';

  var PAGE_ROOT = '.gear-7-page';

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getDocHeight() {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight
    );
  }

  function initVideoStrip() {
    var root = document.querySelector(PAGE_ROOT) || document;
    if (!root) return;

    root.querySelectorAll('.video-track video').forEach(function (video) {
      if (video.dataset.gear7VideoBound === 'true') return;
      video.dataset.gear7VideoBound = 'true';
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');

      var play = function () {
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      };

      video.addEventListener('canplay', play, { once: true });
      play();
    });
  }

  function initStickyOffer() {
    var root = document.querySelector(PAGE_ROOT) || document;
    var hero = root.querySelector('section.hero') || document.querySelector('section.hero');
    var bar = root.querySelector('.sticky-offer') || document.querySelector('.sticky-offer');
    if (!hero || !bar) return;

    if (bar.dataset.gear7StickyBound === 'true') return;
    bar.dataset.gear7StickyBound = 'true';

    var update = function () {
      var rect = hero.getBoundingClientRect();
      var pastHero = rect.bottom < 80;
      var scrollY = getScrollY();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var nearBottom = scrollY + viewportH >= getDocHeight() - 160;
      var visible = pastHero && !nearBottom;

      bar.classList.toggle('show', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    initVideoStrip();
    initStickyOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
